import { createVNode as _createVNode, resolveComponent as _resolveComponent, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "card-body p-0" }
const _hoisted_2 = { class: "d-flex flex-stack" }
const _hoisted_3 = /*#__PURE__*/_createVNode("h3", { class: "m-0 text-white fw-bolder fs-3" }, "Sales Summary", -1)
const _hoisted_4 = { class: "ms-1" }
const _hoisted_5 = { class: "svg-icon svg-icon-2" }
const _hoisted_6 = /*#__PURE__*/_createVNode("div", { class: "d-flex text-center flex-column text-white pt-8" }, [
  /*#__PURE__*/_createVNode("span", { class: "fw-bold fs-7" }, "You Balance"),
  /*#__PURE__*/_createVNode("span", { class: "fw-bolder fs-2x pt-1" }, "$37,562.00")
], -1)
const _hoisted_7 = {
  class: "\n          shadow-xs\n          card-rounded\n          mx-9\n          mb-9\n          px-6\n          py-9\n          position-relative\n          z-index-1\n          bg-white\n        ",
  style: {"margin-top":"-100px"}
}
const _hoisted_8 = { class: "symbol symbol-45px w-40px me-5" }
const _hoisted_9 = { class: "symbol-label bg-lighten" }
const _hoisted_10 = { class: "svg-icon svg-icon-1" }
const _hoisted_11 = { class: "d-flex align-items-center flex-wrap w-100" }
const _hoisted_12 = { class: "mb-1 pe-3 flex-grow-1" }
const _hoisted_13 = {
  href: "#",
  class: "fs-5 text-gray-800 text-hover-primary fw-bolder"
}
const _hoisted_14 = { class: "text-gray-400 fw-bold fs-7" }
const _hoisted_15 = { class: "d-flex align-items-center" }
const _hoisted_16 = { class: "fw-bolder fs-5 text-gray-800 pe-1" }
const _hoisted_17 = {
  key: 0,
  class: "svg-icon svg-icon-5 svg-icon-success ms-1"
}
const _hoisted_18 = {
  key: 1,
  class: "svg-icon svg-icon-5 svg-icon-danger ms-1"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_Dropdown3 = _resolveComponent("Dropdown3")!

  return (_openBlock(), _createBlock("div", {
    class: [_ctx.widgetClasses, "card"]
  }, [
    _createVNode("div", _hoisted_1, [
      _createVNode("div", {
        class: [`bg-${_ctx.widgetColor}`, "px-9 pt-7 card-rounded h-275px w-100"]
      }, [
        _createVNode("div", _hoisted_2, [
          _hoisted_3,
          _createVNode("div", _hoisted_4, [
            _createVNode("button", {
              type: "button",
              class: [`btn-active-color-${_ctx.widgetColor}`, "\n                btn btn-sm btn-icon btn-color-white btn-active-white\n                border-0\n                me-n3\n              "],
              "data-kt-menu-trigger": "click",
              "data-kt-menu-placement": "bottom-end",
              "data-kt-menu-flip": "top-end"
            }, [
              _createVNode("span", _hoisted_5, [
                _createVNode(_component_inline_svg, { src: "media/icons/duotune/general/gen024.svg" })
              ])
            ], 2),
            _createVNode(_component_Dropdown3)
          ])
        ]),
        _hoisted_6
      ], 2),
      _createVNode("div", _hoisted_7, [
        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.items, (item, index) => {
          return (_openBlock(), _createBlock("div", {
            key: index,
            class: [[index !== _ctx.items.length && 'mb-7'], "d-flex align-items-center"]
          }, [
            _createVNode("div", _hoisted_8, [
              _createVNode("span", _hoisted_9, [
                _createVNode("span", _hoisted_10, [
                  _createVNode(_component_inline_svg, {
                    src: item.icon
                  }, null, 8, ["src"])
                ])
              ])
            ]),
            _createVNode("div", _hoisted_11, [
              _createVNode("div", _hoisted_12, [
                _createVNode("a", _hoisted_13, _toDisplayString(item.title), 1),
                _createVNode("div", _hoisted_14, _toDisplayString(item.description), 1)
              ]),
              _createVNode("div", _hoisted_15, [
                _createVNode("div", _hoisted_16, _toDisplayString(item.stats), 1),
                (item.arrow === 'up')
                  ? (_openBlock(), _createBlock("span", _hoisted_17, [
                      _createVNode(_component_inline_svg, { src: "media/icons/duotune/arrows/arr066.svg" })
                    ]))
                  : (item.arrow === 'down')
                    ? (_openBlock(), _createBlock("span", _hoisted_18, [
                        _createVNode(_component_inline_svg, { src: "media/icons/duotune/arrows/arr065.svg" })
                      ]))
                    : _createCommentVNode("", true)
              ])
            ])
          ], 2))
        }), 128))
      ])
    ])
  ], 2))
}